import React, { useState,useRef ,useEffect} from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import location from '../Icons/location.svg';
import arrow from '../Icons/arrow.svg';
import uploadicon from '../Icons/upload white.svg';
import add from '../Icons/Add.svg';
import deleteicon from '../Icons/delete.svg';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import removeIcon from '../Icons/Close-white.svg';
import Select from 'react-select';
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import '../Customize_Css/AddVendor.css';
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";

// Fix Leaflet marker icon issue in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
});

const AddIndependentDelivery = () => {
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [timeAvailabilitySlot, setTimeAvailabilitySlot] = useState([]);
  const [daySlot, setDaySlot] = useState([]);
  const [locationButtonText, setLocationButtonText] = useState("Current Location");
  const AuthorizationToken = localStorage.getItem('token');
  // map states
  const [isMapOpen, setIsMapOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [manualLat, setManualLat] = useState("");
  const [manualLng, setManualLng] = useState("");
  const [mapMarker, setMapMarker] = useState(null);
  const mapRef = useRef(null);

  const mapCenter = [11.0168, 76.9558]; // Default center (you can change)
  const mapZoom = 13;

  const [documents, setDocuments] = useState([{
    name: '',
    number: '',
    upload: null,
    type: '',
    expiryDate: '',
  }]);

  const [independentDelivery, setIndependentDelivery] = useState({
    fullName: '',
    emailAddress: '',
    degree: '',
    customDegree: '', 
    dateOfBirth: '',
    address: '',
    primaryMobileNumber: '',
    whatsappNumber: '',
    language: JSON.stringify([]),
    country: '',
    state: '',
    city: '',
    bloodGroup: '',
    useMyLocation: { latitude: '', longitude: '' },
    currentLocation: '',
    nameOfEmergency: '',
    relationshipToAccountHolder: '',
    emergencyPhoneNumber: '',
    emergencyEmailAddress: '',
    emergencyAddress: '',
    alternateContactPersonName: '',
    relationshipToAlternateContactPerson: '',
    alternateContactPersonNumber: '',
    alternateContactPersonAddress: '',
    toPickupLocationTime: '',
    toDeliveryLocationTime: '',
    maximumDeliveryCapacity: '',
    accountHoldersName: '',
    typeOfAccount: '',
    accountNumber: '',
    ifscCode: '',
    branchName: '',
    gpayNumber: '',
    bankAddress: '',
  });

  const [files, setFiles] = useState({
    profilePictureFile: null,
  });

  const languageOptions = [
    { value: 'english', label: 'English' },
    { value: 'spanish', label: 'Spanish' },
    { value: 'french', label: 'French' },
    { value: 'german', label: 'German' },
    { value: 'chinese', label: 'Chinese' },
    { value: 'japanese', label: 'Japanese' },
    { value: 'hindi', label: 'Hindi' },
    { value: 'arabic', label: 'Arabic' },
  ];

  const documentOptions = [
    { value: 'Aadhar Card', label: 'Aadhar Card' },
    { value: 'PAN Card', label: 'PAN Card' },
    { value: 'Driving License', label: 'Driving License' },
    { value: 'Passport', label: 'Passport' },
    { value: 'Voter ID', label: 'Voter ID' },
  ];

  const bloodGroupOptions = [
    { value: '', label: 'Select your blood group' },
    { value: 'A+', label: 'A+' },
    { value: 'A-', label: 'A-' },
    { value: 'B+', label: 'B+' },
    { value: 'B-', label: 'B-' },
    { value: 'AB+', label: 'AB+' },
    { value: 'AB-', label: 'AB-' },
    { value: 'O+', label: 'O+' },
    { value: 'O-', label: 'O-' },
  ];

  const degreeOptions = [
    { value: '', label: 'Select the degree' },
    { value: 'High School', label: 'High School' },
    { value: 'Diploma', label: 'Diploma' },
    { value: 'Bachelor\'s Degree', label: 'Bachelor\'s Degree' },
    { value: 'Master\'s Degree', label: 'Master\'s Degree' },
    { value: 'PhD', label: 'PhD' },
    { value: 'Other', label: 'Other' },
  ];

  const relationshipOptions = [
    { value: 'Mother', label: 'Mother' },
    { value: 'Father', label: 'Father' },
    { value: 'Daughter', label: 'Daughter' },
    { value: 'Son', label: 'Son' },
    { value: 'Husband', label: 'Husband' },
    { value: 'Wife', label: 'Wife' },
    { value: 'Other', label: 'Other' },
  ];

  // Helper functions for validation
  const isEmpty = (value) => !value || (typeof value === 'string' && value.trim() === '');
  const isValidEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  const isValidMobileNumber = (number) => /^\d{10}$/.test(number);
  const isValidIFSC = (ifsc) => /^[A-Za-z]{4}\d{7}$/.test(ifsc);
  const isValidNumber = (value) => !isNaN(value) && Number(value) > 0;
  const isPastDate = (date) => date && new Date(date) < new Date();
  const isValidLocation = (location) => location && location.latitude && location.longitude;

  // Real-time field validation with documentation
  const validateField = (name, value) => {
    let error = '';
    let isValid = true;

    switch (name) {
      case 'fullName':
      case 'address':
      case 'country':
      case 'state':
      case 'city':
      case 'nameOfEmergency':
      case 'relationshipToAccountHolder':
      case 'emergencyAddress':
      case 'accountHoldersName':
      case 'typeOfAccount':
      case 'branchName':
      case 'bankAddress':
      case 'currentLocation':
        if (isEmpty(value)) {
          error = `${name.replace(/([A-Z])/g, ' $1').trim()} is required`;
          isValid = false;
        }
        break;

      case 'emailAddress':
      case 'emergencyEmailAddress':
        if (isEmpty(value) || !isValidEmail(value)) {
          error = `Valid ${name.replace(/([A-Z])/g, ' $1').trim()} is required`;
          isValid = false;
        }
        break;

      case 'primaryMobileNumber':
      case 'whatsappNumber':
      case 'emergencyPhoneNumber':
      case 'gpayNumber':
      // case 'alternateContactPersonNumber':
        if (isEmpty(value)) {
          error = `${name.replace(/([A-Z])/g, ' $1').trim()} is required`;
          isValid = false;
        } else if (!isValidMobileNumber(value)) {
          error = `${name.replace(/([A-Z])/g, ' $1').trim()} must be a valid 10-digit number`;
          isValid = false;
        }
        break;

      case 'dateOfBirth':
        if (isEmpty(value) || !isPastDate(value)) {
          error = 'Date of Birth must be in the past';
          isValid = false;
        }
        break;

      case 'degree':
        if (isEmpty(value)) {
          error = 'Degree is required';
          isValid = false;
        }
        break;

      case 'customDegree':
        if (independentDelivery.degree === 'Other' && isEmpty(value)) {
          error = 'Custom degree is required when Other is selected';
          isValid = false;
        }
        break;

      case 'customRelationship':
        if (independentDelivery.relationshipToAccountHolder === 'Other' && isEmpty(value)) {
          error = 'Custom relationship is required when Other is selected';
          isValid = false;
        }
        break;

      case 'bloodGroup':
        if (isEmpty(value)) {
          error = 'Blood Group is required';
          isValid = false;
        }
        break;

      case 'toPickupLocationTime':
      case 'toDeliveryLocationTime':
      case 'maximumDeliveryCapacity':
        if (isEmpty(value) || !isValidNumber(value)) {
          error = `${name.replace(/([A-Z])/g, ' $1').trim()} must be a valid number`;
          isValid = false;
        }
        break;

      case 'accountNumber':
        if (isEmpty(value) || !/^\d+$/.test(value)) {
          error = 'Account Number must be a valid number';
          isValid = false;
        }
        break;

      case 'ifscCode':
        if (isEmpty(value) || !isValidIFSC(value)) {
          error = 'Valid IFSC Code is required';
          isValid = false;
        }
        break;

      case 'language':
        if (!value || JSON.parse(value).length === 0) {
          error = 'At least one language must be selected';
          isValid = false;
        }
        break;

      case 'useMyLocation':
        if (!isValidLocation(value)) {
          error = 'You must pick your location';
          isValid = false;
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
    setValidFields((prev) => ({ ...prev, [name]: isValid && !error }));
  };

  // Form validation on submit
  const validateFormDeliveryVendor = () => {
    let isValid = true;
    const fieldsToValidate = Object.keys(independentDelivery).filter(field => field !== 'customDegree' && field !== 'customRelationship');

    fieldsToValidate.forEach((field) => {
      validateField(field, independentDelivery[field]);
      if (errors[field]) isValid = false;
    });

    if (independentDelivery.degree === 'Other') {
      validateField('customDegree', independentDelivery.customDegree);
      if (errors.customDegree) isValid = false;
    }

    if (independentDelivery.relationshipToAccountHolder === 'Other') {
      validateField('customRelationship', independentDelivery.customRelationship);
      if (errors.customRelationship) isValid = false;
    }

    if (timeAvailabilitySlot.length === 0) {
      setErrors((prev) => ({ ...prev, timeAvailabilitySlot: 'Select at least one Time Slot' }));
      setValidFields((prev) => ({ ...prev, timeAvailabilitySlot: false }));
      isValid = false;
    } else {
      setErrors((prev) => ({ ...prev, timeAvailabilitySlot: '' }));
      setValidFields((prev) => ({ ...prev, timeAvailabilitySlot: true }));
    }

    if (daySlot.length === 0) {
      setErrors((prev) => ({ ...prev, daySlot: 'Select at least one Day Slot' }));
      setValidFields((prev) => ({ ...prev, daySlot: false }));
      isValid = false;
    } else {
      setErrors((prev) => ({ ...prev, daySlot: '' }));
      setValidFields((prev) => ({ ...prev, daySlot: true }));
    }

    const uploadMatchesSelectedType = (doc) => {
      if (!doc.upload || !doc.type) return false;
      if (!(doc.upload instanceof File)) return true;
      return fileMatchesDocumentType(doc.upload, doc.type);
    };

    if (!documents.every((doc) => doc.name && String(doc.number || '').trim() && uploadMatchesSelectedType(doc))) {
      const nextErrors = {};
      const nextValid = {};
      documents.forEach((doc, index) => {
        nextErrors[`documenttype${index}`] = doc.type ? '' : 'Document Type is required';
        nextValid[`documenttype${index}`] = Boolean(doc.type);
        nextErrors[`documentnumber${index}`] = String(doc.number || '').trim() ? '' : 'Document Number is required';
        nextValid[`documentnumber${index}`] = Boolean(String(doc.number || '').trim());
        if (!doc.upload) {
          nextErrors[`documentupload${index}`] = doc.type ? 'File upload is required' : 'Select a document type before uploading';
          nextValid[`documentupload${index}`] = false;
        } else if (doc.upload instanceof File && doc.type && !fileMatchesDocumentType(doc.upload, doc.type)) {
          nextErrors[`documentupload${index}`] = `Only ${doc.type.toUpperCase()} files can be uploaded`;
          nextValid[`documentupload${index}`] = false;
        } else {
          nextErrors[`documentupload${index}`] = '';
          nextValid[`documentupload${index}`] = true;
        }
      });
      setErrors((prev) => ({ ...prev, ...nextErrors, documents: 'All document fields (Name, Number, Upload, Type) are required' }));
      setValidFields((prev) => ({ ...prev, ...nextValid, documents: false }));
      isValid = false;
    } else {
      const nextErrors = { documents: '' };
      const nextValid = { documents: true };
      documents.forEach((doc, index) => {
        nextErrors[`documenttype${index}`] = '';
        nextErrors[`documentnumber${index}`] = '';
        nextErrors[`documentupload${index}`] = '';
        nextValid[`documenttype${index}`] = true;
        nextValid[`documentnumber${index}`] = true;
        nextValid[`documentupload${index}`] = true;
      });
      setErrors((prev) => ({ ...prev, ...nextErrors }));
      setValidFields((prev) => ({ ...prev, ...nextValid }));
    }

    // Check for duplicate document names
    const docNames = documents.map(doc => doc.name).filter(name => name);
    if (new Set(docNames).size !== docNames.length) {
      setErrors((prev) => ({ ...prev, documents: 'Each document name must be unique' }));
      setValidFields((prev) => ({ ...prev, documents: false }));
      isValid = false;
    }

    if (!files.profilePictureFile) {
      setErrors((prev) => ({ ...prev, profilePictureFile: 'Profile picture is required' }));
      setValidFields((prev) => ({ ...prev, profilePictureFile: false }));
      isValid = false;
    } else {
      setErrors((prev) => ({ ...prev, profilePictureFile: '' }));
      setValidFields((prev) => ({ ...prev, profilePictureFile: true }));
    }

    return isValid;
  };

  const handleInputChangeIndependent = (e) => {
    const { name, value } = e.target;
    // Restrict input to 10 digits for specific fields
    if (
      name === 'primaryMobileNumber' ||
      name === 'whatsappNumber' ||
      name === 'emergencyPhoneNumber' ||
      name === 'gpayNumber' ||
      name === 'alternateContactPersonNumber'
    ) {
      if (value.length <= 10) {
        setIndependentDelivery((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        validateField(name, value);
      }
    } else {
      setIndependentDelivery((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      validateField(name, value);
    }
  };

  const handleLanguageChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setIndependentDelivery((prev) => ({
      ...prev,
      language: JSON.stringify(selectedValues),
    }));
    validateField('language', JSON.stringify(selectedValues));
  };

  const handleButtonClick = (time) => {
    setTimeAvailabilitySlot([time]);
    setErrors((prev) => ({ ...prev, timeAvailabilitySlot: '' }));
    setValidFields((prev) => ({ ...prev, timeAvailabilitySlot: true }));
  };

  const handleDaysButtonClick = (day) => {
    const updatedDays = daySlot.includes(day) ? daySlot.filter((d) => d !== day) : [...daySlot, day];
    setDaySlot(updatedDays);
    if (updatedDays.length > 0) {
      setErrors((prev) => ({ ...prev, daySlot: '' }));
      setValidFields((prev) => ({ ...prev, daySlot: true }));
    } else {
      setErrors((prev) => ({ ...prev, daySlot: 'Select at least one Day Slot' }));
      setValidFields((prev) => ({ ...prev, daySlot: false }));
    }
  };

  // const handleLocationClick = () => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const { latitude, longitude } = position.coords;
  //         setIndependentDelivery((prevFormData) => ({
  //           ...prevFormData,
  //           useMyLocation: { latitude: latitude.toString(), longitude: longitude.toString() },
  //         }));
  //         setLocationButtonText("Location Picked");
  //         validateField('useMyLocation', { latitude: latitude.toString(), longitude: longitude.toString() });
  //       },
  //       (error) => {
  //         console.error('Error getting location:', error);
  //         toast.error('Unable to fetch location');
  //       },
  //       { timeout: 10000 }
  //     );
  //   } else {
  //     toast.error('Geolocation is not supported by this browser.');
  //   }
  // };

  const documentTypeAccept = {
    pdf: '.pdf,application/pdf',
    doc: '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    jpg: '.jpg,image/jpeg',
    jpeg: '.jpeg,.jpg,image/jpeg',
    png: '.png,image/png',
  };

  const fileMatchesDocumentType = (file, type) => {
    if (!file || !type) return false;
    const name = file.name.toLowerCase();
    const mime = (file.type || '').toLowerCase();
    if (type === 'pdf') return name.endsWith('.pdf') || mime === 'application/pdf';
    if (type === 'doc') return name.endsWith('.doc') || name.endsWith('.docx') || mime.includes('word') || mime.includes('msword');
    if (type === 'png') return name.endsWith('.png') || mime === 'image/png';
    if (type === 'jpg' || type === 'jpeg') return name.endsWith('.jpg') || name.endsWith('.jpeg') || mime === 'image/jpeg';
    return false;
  };

  const handleFileChange = (index, event) => {
    const file = event.target.files[0];
    event.target.value = '';
    const selectedType = documents[index]?.type;
    if (!selectedType) {
      setErrors((prev) => ({ ...prev, [`documenttype${index}`]: 'Select a document type before uploading', [`documentupload${index}`]: 'Select a document type before uploading' }));
      setValidFields((prev) => ({ ...prev, [`documenttype${index}`]: false, [`documentupload${index}`]: false }));
      return;
    }
    if (!file) return;
    if (!fileMatchesDocumentType(file, selectedType)) {
      setErrors((prev) => ({ ...prev, [`documentupload${index}`]: `Only ${selectedType.toUpperCase()} files can be uploaded` }));
      setValidFields((prev) => ({ ...prev, [`documentupload${index}`]: false }));
      return;
    }
    const updatedDocuments = [...documents];
    updatedDocuments[index].upload = file;
    updatedDocuments[index].fileName = file.name;
    setDocuments(updatedDocuments);
    setErrors((prev) => ({ ...prev, [`documentupload${index}`]: '' }));
    setValidFields((prev) => ({ ...prev, [`documentupload${index}`]: true }));
    validateField('documents', updatedDocuments);
  };

  const removeFile = (index) => {
    const updatedDocuments = [...documents];
    updatedDocuments[index].upload = null;
    updatedDocuments[index].fileName = '';
    setDocuments(updatedDocuments);
    setErrors((prev) => ({ ...prev, [`documentupload${index}`]: 'File upload is required' }));
    setValidFields((prev) => ({ ...prev, [`documentupload${index}`]: false }));
    validateField('documents', updatedDocuments);
  };

  const handleChange = (index, field, value) => {
    const updatedDocuments = [...documents];
    updatedDocuments[index][field] = value;
    if (field === 'type' && updatedDocuments[index].upload && !fileMatchesDocumentType(updatedDocuments[index].upload, value)) {
      updatedDocuments[index].upload = null;
      updatedDocuments[index].fileName = '';
      setErrors((prev) => ({ ...prev, [`documentupload${index}`]: value ? `Only ${value.toUpperCase()} files can be uploaded` : '' }));
      setValidFields((prev) => ({ ...prev, [`documentupload${index}`]: false }));
    }
    if (field === 'type') {
      setErrors((prev) => ({ ...prev, [`documenttype${index}`]: value ? '' : 'Document Type is required' }));
      setValidFields((prev) => ({ ...prev, [`documenttype${index}`]: Boolean(value) }));
    }
    if (field === 'number') {
      setErrors((prev) => ({ ...prev, [`documentnumber${index}`]: value.trim() ? '' : 'Document Number is required' }));
      setValidFields((prev) => ({ ...prev, [`documentnumber${index}`]: Boolean(value.trim()) }));
    }
    setDocuments(updatedDocuments);
    validateField('documents', updatedDocuments);
  };

  const handleDocumentChange = (index, selectedOption) => {
    const updatedDocuments = [...documents];
    updatedDocuments[index].name = selectedOption ? selectedOption.value : '';
    setDocuments(updatedDocuments);
    validateField('documents', updatedDocuments);
  };

  const addRow = () => {
    setDocuments([...documents, { name: '', number: '', upload: null, type: '', expiryDate: '' }]);
  };

  const deleteRow = (index) => {
    if (documents.length <= 1) {
      toast.error("At least one document must remain.");
      return;
    }
    const updatedDocuments = documents.filter((_, i) => i !== index);
    setDocuments(updatedDocuments);
    validateField('documents', updatedDocuments);
  };

  const handleFileChangeProfile = (event) => {
    const { name, files } = event.target;
    if (files && files[0]) {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [name]: files[0],
      }));
      validateField('profilePictureFile', files[0]);
    }
  };

  const handleFileRemove = () => {
    setFiles((prevFiles) => ({
      ...prevFiles,
      profilePictureFile: null,
    }));
    validateField('profilePictureFile', null);
  };

  const handleAccountTypeChange = (typeOfAccount) => {
    setIndependentDelivery((prevFormData) => ({
      ...prevFormData,
      typeOfAccount: typeOfAccount,
    }));
    validateField('typeOfAccount', typeOfAccount);
  };

  const handleBloodGroupChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : '';
    setIndependentDelivery((prev) => ({
      ...prev,
      bloodGroup: value,
    }));
    validateField('bloodGroup', value);
  };

  const handleDegreeChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : '';
    setIndependentDelivery((prev) => ({
      ...prev,
      degree: value,
      customDegree: value === 'Other' ? prev.customDegree : '', // Reset customDegree if not Other
    }));
    validateField('degree', value);
    if (value !== 'Other') {
      validateField('customDegree', '');
    }
  };

  const handleCustomDegreeChange = (e) => {
    const value = e.target.value;
    setIndependentDelivery((prev) => ({
      ...prev,
      customDegree: value,
    }));
    validateField('customDegree', value);
  };

  const handleRelationshipChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : '';
    setIndependentDelivery((prev) => ({
      ...prev,
      relationshipToAccountHolder: value,
      customRelationship: value === 'Other' ? prev.customRelationship : '', // Reset customRelationship if not Other
    }));
    validateField('relationshipToAccountHolder', value);
    if (value !== 'Other') {
      validateField('customRelationship', '');
    }
  };

  const handleCustomRelationshipChange = (e) => {
    const value = e.target.value;
    setIndependentDelivery((prev) => ({
      ...prev,
      customRelationship: value,
    }));
    validateField('customRelationship', value);
  };

  // Filter available document options for each row
  const getAvailableDocumentOptions = (currentIndex) => {
    const selectedDocs = documents
      .map((doc, index) => index !== currentIndex ? doc.name : null)
      .filter(name => name);
    return documentOptions.filter(option => !selectedDocs.includes(option.value));
  };

  const resetForm = () => {
    setIndependentDelivery({
      fullName: '',
      emailAddress: '',
      degree: '',
      customDegree: '',
      dateOfBirth: '',
      address: '',
      primaryMobileNumber: '',
      whatsappNumber: '',
      language: JSON.stringify([]),
      country: '',
      state: '',
      city: '',
      bloodGroup: '',
      useMyLocation: { latitude: '', longitude: '' },
      currentLocation: '',
      nameOfEmergency: '',
      relationshipToAccountHolder: '',
      customRelationship: '',
      emergencyPhoneNumber: '',
      emergencyEmailAddress: '',
      emergencyAddress: '',
      alternateContactPersonName: '',
      relationshipToAlternateContactPerson: '',
      alternateContactPersonNumber: '',
      alternateContactPersonAddress: '',
      toPickupLocationTime: '',
      toDeliveryLocationTime: '',
      maximumDeliveryCapacity: '',
      accountHoldersName: '',
      typeOfAccount: '',
      accountNumber: '',
      ifscCode: '',
      branchName: '',
      gpayNumber: '',
      bankAddress: '',
    });
    setFiles({ profilePictureFile: null });
    setDocuments([{
      name: '',
      number: '',
      upload: null,
      type: '',
      expiryDate: '',
    }]);
    setTimeAvailabilitySlot([]);
    setDaySlot([]);
    // setLocationButtonText("Current Location");
    setErrors({});
    setValidFields({});
    setSelectedLocation(null);
    setMapMarker(null);
    setManualLat("");
    setManualLng("");
    setSearchQuery("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFormDeliveryVendor()) {
      toast.error('Please fill all required fields correctly');
      return;
    }

    setIsSubmitting(true);

    const data = new FormData();
    if (files.profilePictureFile) {
      data.append('profileImage', files.profilePictureFile);
    }

    const updatedFormData = {
      ...independentDelivery,
      degree: independentDelivery.degree === 'Other' ? independentDelivery.customDegree : independentDelivery.degree, // Use customDegree if Other
      relationshipToAccountHolder: independentDelivery.relationshipToAccountHolder === 'Other' ? independentDelivery.customRelationship : independentDelivery.relationshipToAccountHolder, // Use customRelationship if Other
      timeAvailabilitySlot: JSON.stringify(timeAvailabilitySlot),
      // selectDay: JSON.stringify(daySlot),
      daySlot: JSON.stringify(daySlot),
      documents: JSON.stringify(
        documents.map((doc) => ({
          documentName: doc.name,
          documentNumber: doc.number,
          documentType: doc.type,
          documentExpiryDate: doc.expiryDate,
        }))
      ),
    };

    // Stringify useMyLocation and language for FormData
    data.append('useMyLocation', JSON.stringify(updatedFormData.useMyLocation));
    data.append('language', updatedFormData.language);
    for (const key in updatedFormData) {
      if (key !== 'useMyLocation' && key !== 'language' && key !== 'customDegree' && key !== 'customRelationship') {
        data.append(key, updatedFormData[key]);
      }
    }

    documents.forEach((doc, index) => {
      if (doc.upload) {
        data.append(`document_${index}`, doc.upload);
      }
    });

    const epicxTenantId = localStorage.getItem('epicxTenantId');
    if (!epicxTenantId) {
      console.error('Tenant ID is not provided');
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/independentDelivery/api/independentDelivery/${epicxTenantId}`,
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${AuthorizationToken}`,
          },
        }
      );
      console.log('Response:', response.data);
      toast.success('Independent Delivery added successfully!');
      resetForm();
      setIsSubmitting(false);
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      toast.error('Error adding independent delivery. Please try again.');
      setIsSubmitting(false);
    }
  };

  const Input = styled('input')({
    display: 'none',
  });
function MapClickHandler({ onSelect }) {
  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      onSelect({ lat, lng });
    },
  });
  return null;
}
const updateLocation = (loc) => {
  setSelectedLocation(loc);
  setMapMarker(loc);
  setManualLat(loc.lat.toFixed(6));
  setManualLng(loc.lng.toFixed(6));

  // Update the main form state
  setIndependentDelivery(prev => ({
    ...prev,
    useMyLocation: {
      latitude: loc.lat.toString(),
      longitude: loc.lng.toString()
    }
  }));
  validateField('useMyLocation', { latitude: loc.lat.toString(), longitude: loc.lng.toString() });
};

const handleGeocode = async () => {
  if (!searchQuery.trim()) return;

  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}`
    );
    const data = await res.json();
    if (data.length === 0) {
      toast.error("Location not found");
      return;
    }
    const { lat, lon } = data[0];
    const newLoc = { lat: parseFloat(lat), lng: parseFloat(lon) };
    updateLocation(newLoc);

    if (mapRef.current) {
      mapRef.current.setView(newLoc, 16);
    }
  } catch (err) {
    toast.error("Search failed");
  }
};

useEffect(() => {
  if (isMapOpen && mapRef.current) {
    setTimeout(() => mapRef.current?.invalidateSize(), 100);
  }
}, [isMapOpen]);

  return (
    <>
      <Sidebar />
      <div className="vendor-form-page">
        <div className="vendor-form-shell">
          <header className="vendor-form-hero">
            <div>
              <p className="vendor-form-kicker">Vendors</p>
              <h1>Add Independent Delivery</h1>
              <p>Enter person details, emergency contact, schedule, bank, and documents. Required fields stay the same.</p>
            </div>
            <button type="button" className="vendor-form-back-btn" onClick={() => window.history.back()}>
              Back to list
            </button>
          </header>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div className="vendor-form-card">
              <div className="vendor-form-card-head">
                <div>
                  <h2>Independent Delivery Person Information</h2>
                  <p>Name, contact, location, availability, and profile photo.</p>
                </div>
              </div>
              <div className="vendor-form-card-body">
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="fullName">Full Name <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.fullName ? 'is-invalid' : validFields.fullName ? 'is-valid' : ''}`}
                      id="fullName"
                      name="fullName"
                      value={independentDelivery.fullName}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('fullName', e.target.value)}
                    />
                    {errors.fullName && <small className="text-danger">{errors.fullName}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="emailAddress">Email Address <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="email"
                      className={`form-control bg-light ${errors.emailAddress ? 'is-invalid' : validFields.emailAddress ? 'is-valid' : ''}`}
                      id="emailAddress"
                      name="emailAddress"
                      value={independentDelivery.emailAddress}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('emailAddress', e.target.value)}
                    />
                    {errors.emailAddress && <small className="text-danger">{errors.emailAddress}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="degree">Degree <span style={{ color: 'red' }}>*</span></label>
                    <Select
                      options={degreeOptions}
                      className={`basic-single ${errors.degree ? 'is-invalid' : validFields.degree ? 'is-valid' : ''}`}
                      id="degree"
                      placeholder="Select Degree"
                      onChange={handleDegreeChange}
                      value={degreeOptions.find((option) => option.value === independentDelivery.degree)}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#fff',
                          borderColor: errors.degree ? '#dc3545' : validFields.degree ? '#28a745' : '#ced4da',
                          boxShadow: 'none',
                          '&:hover': { borderColor: errors.degree ? '#dc3545' : validFields.degree ? '#28a745' : '#ced4da' },
                        }),
                      }}
                    />
                    {independentDelivery.degree === 'Other' && (
                      <input
                        type="text"
                        className={`form-control bg-light mt-2 ${errors.customDegree ? 'is-invalid' : validFields.customDegree ? 'is-valid' : ''}`}
                        placeholder="Enter Custom Degree"
                        name="customDegree"
                        value={independentDelivery.customDegree}
                        onChange={handleCustomDegreeChange}
                        onBlur={(e) => validateField('customDegree', e.target.value)}
                      />
                    )}
                    {errors.degree && <small className="text-danger">{errors.degree}</small>}
                    {errors.customDegree && <small className="text-danger">{errors.customDegree}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="bloodGroup">Blood Group <span style={{ color: 'red' }}>*</span></label>
                    <Select
                      options={bloodGroupOptions}
                      className={`basic-single ${errors.bloodGroup ? 'is-invalid' : validFields.bloodGroup ? 'is-valid' : ''}`}
                      id="bloodGroup"
                      placeholder="Select Blood Group"
                      onChange={handleBloodGroupChange}
                      value={bloodGroupOptions.find((option) => option.value === independentDelivery.bloodGroup)}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#fff',
                          borderColor: errors.bloodGroup ? '#dc3545' : validFields.bloodGroup ? '#28a745' : '#ced4da',
                          boxShadow: 'none',
                          '&:hover': { borderColor: errors.bloodGroup ? '#dc3545' : validFields.bloodGroup ? '#28a745' : '#ced4da' },
                        }),
                      }}
                    />
                    {errors.bloodGroup && <small className="text-danger">{errors.bloodGroup}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="dateOfBirth">Date Of Birth <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="date"
                      className={`form-control bg-light ${errors.dateOfBirth ? 'is-invalid' : validFields.dateOfBirth ? 'is-valid' : ''}`}
                      id="dateOfBirth"
                      name="dateOfBirth"
                      value={independentDelivery.dateOfBirth}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('dateOfBirth', e.target.value)}
                    />
                    {errors.dateOfBirth && <small className="text-danger">{errors.dateOfBirth}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="primaryMobileNumber">Primary Mobile Number <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.primaryMobileNumber ? 'is-invalid' : validFields.primaryMobileNumber ? 'is-valid' : ''}`}
                      id="primaryMobileNumber"
                      name="primaryMobileNumber"
                      value={independentDelivery.primaryMobileNumber}
                      onChange={handleInputChangeIndependent}
                      maxLength="10"
                      pattern="\d*"
                      inputMode="numeric"
                      onBlur={(e) => validateField('primaryMobileNumber', e.target.value)}
                    />
                    {errors.primaryMobileNumber && <small className="text-danger">{errors.primaryMobileNumber}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="whatsappNumber">Whatsapp Number <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.whatsappNumber ? 'is-invalid' : validFields.whatsappNumber ? 'is-valid' : ''}`}
                      id="whatsappNumber"
                      name="whatsappNumber"
                      value={independentDelivery.whatsappNumber}
                      onChange={handleInputChangeIndependent}
                      maxLength="10"
                      pattern="\d*"
                      inputMode="numeric"
                      onBlur={(e) => validateField('whatsappNumber', e.target.value)}
                    />
                    {errors.whatsappNumber && <small className="text-danger">{errors.whatsappNumber}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="language">Language <span style={{ color: 'red' }}>*</span></label>
                    <Select
                      isMulti
                      options={languageOptions}
                      className={`basic-multi-select ${errors.language ? 'is-invalid' : validFields.language ? 'is-valid' : ''}`}
                      id="language"
                      placeholder="Select Languages"
                      onChange={handleLanguageChange}
                      value={languageOptions.filter((option) => JSON.parse(independentDelivery.language).includes(option.value))}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#fff',
                          borderColor: errors.language ? '#dc3545' : validFields.language ? '#28a745' : '#ced4da',
                          boxShadow: 'none',
                          '&:hover': { borderColor: errors.language ? '#dc3545' : validFields.language ? '#28a745' : '#ced4da' },
                        }),
                      }}
                    />
                    {errors.language && <small className="text-danger">{errors.language}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="country">Country <span style={{ color: 'red' }}>*</span></label>
                    <select
                      id="country"
                      className={`form-control bg-light ${errors.country ? 'is-invalid' : validFields.country ? 'is-valid' : ''}`}
                      style={{ color: 'gray' }}
                      name="country"
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('country', e.target.value)}
                      value={independentDelivery.country}
                    >
                      <option value="">Select Country</option>
                      <option value="India">India</option>
                    </select>
                    {errors.country && <small className="text-danger">{errors.country}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="state">State <span style={{ color: 'red' }}>*</span></label>
                    <select
                      id="state"
                      className={`form-control bg-light ${errors.state ? 'is-invalid' : validFields.state ? 'is-valid' : ''}`}
                      style={{ color: 'gray' }}
                      name="state"
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('state', e.target.value)}
                      value={independentDelivery.state}
                    >
                      <option value="">Select State</option>
                      <option value="Tamil Nadu">Tamil Nadu</option>
                    </select>
                    {errors.state && <small className="text-danger">{errors.state}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="city">City <span style={{ color: 'red' }}>*</span></label>
                    <select
                      id="city"
                      className={`form-control bg-light ${errors.city ? 'is-invalid' : validFields.city ? 'is-valid' : ''}`}
                      style={{ color: 'gray' }}
                      name="city"
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('city', e.target.value)}
                      value={independentDelivery.city}
                    >
                      <option value=''>Select City</option>
                      <option value='Rajapalayam'>Rajapalayam</option>
                      <option value='Sankarankovil'>Sankarankovil</option>
                    </select>
                    {errors.city && <small className="text-danger">{errors.city}</small>}
                  </div>
                  {/* <div className="col-md-4">
                    <label htmlFor="currentLocationButton">Use My Location <span style={{ color: 'red' }}>*</span></label>
                    <button
                      type="button"
                      id="currentLocationButton"
                      className="btn d-flex justify-content-between align-items-center"
                      style={{ backgroundColor: '#00B982', color: 'white', width: '100%' }}
                      onClick={handleLocationClick}
                    >
                      <span>{locationButtonText}</span>
                      <img src={location} alt="location" style={{ width: '20px', height: '20px' }} />
                    </button>
                    {errors.useMyLocation && <small className="text-danger">{errors.useMyLocation}</small>}
                  </div> */}
                  <div className="col-md-4">
                    <label>Use My Location <span style={{ color: 'red' }}>*</span></label>
                    <button
                      type="button"
                      className={`vendor-field-action ${
                        errors.useMyLocation ? 'border-danger' : validFields.useMyLocation ? 'border-success' : ''
                      }`}
                      onClick={() => setIsMapOpen(true)}
                    >
                      <span>
                        {selectedLocation
                          ? `Picked: ${selectedLocation.lat.toFixed(4)}, ${selectedLocation.lng.toFixed(4)}`
                          : 'Select Location on Map'}
                      </span>
                      <img src={location} alt="location" style={{ width: '20px', height: '20px' }} />
                    </button>

                    {selectedLocation && (
                      <button
                        type="button"
                        className="btn btn-sm btn-link text-danger mt-1 p-0"
                        onClick={() => {
                          setSelectedLocation(null);
                          setMapMarker(null);
                          setManualLat("");
                          setManualLng("");
                          setIndependentDelivery(prev => ({
                            ...prev,
                            useMyLocation: { latitude: '', longitude: '' }
                          }));
                          validateField('useMyLocation', { latitude: '', longitude: '' });
                        }}
                      >
                        Clear Location
                      </button>
                    )}

                    {errors.useMyLocation && <small className="text-danger">{errors.useMyLocation}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="currentLocation">Current Location <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.currentLocation ? 'is-invalid' : validFields.currentLocation ? 'is-valid' : ''}`}
                      id="currentLocation"
                      name="currentLocation"
                      value={independentDelivery.currentLocation}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('currentLocation', e.target.value)}
                    />
                    {errors.currentLocation && <small className="text-danger">{errors.currentLocation}</small>}
                  </div>
                  <div className="col-md-8">
                    <label htmlFor="address">Address <span style={{ color: 'red' }}>*</span></label>
                    <textarea
                      className={`form-control bg-light ${errors.address ? 'is-invalid' : validFields.address ? 'is-valid' : ''}`}
                      id="address"
                      rows="2"
                      placeholder="Enter Address Here"
                      name="address"
                      value={independentDelivery.address}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('address', e.target.value)}
                    />
                    {errors.address && <small className="text-danger">{errors.address}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 buttonsgap">
                    <label>Time Availability Slot <span style={{ color: 'red' }}>*</span></label>
                    <div className="btn-group" role="group" aria-label="Time Availability Slot">
                      {['6:00 AM - 10:00 PM', '11:00 AM - 8:00 PM', '9:00 AM - 9:00 PM', '9:30 AM - 10:00 PM', '10:00 AM - 10:00 PM', '12:00 AM - 11:59 PM'].map((time) => (
                        <button
                          key={time}
                          type="button"
                          className={`bg-light btn btn-outline-secondary slot-btn ${timeAvailabilitySlot.includes(time) ? 'active' : ''}`}
                          onClick={() => handleButtonClick(time)}
                        >
                          {time}
                        </button>
                      ))}
                    </div>
                    {errors.timeAvailabilitySlot && <small className="text-danger">{errors.timeAvailabilitySlot}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8 buttonsgap">
                    <label>Day Slot <span style={{ color: 'red' }}>*</span></label>
                    <div className="btn-group" role="group" aria-label="Day Slot">
                      {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day) => (
                        <button
                          key={day}
                          type="button"
                          className={`bg-light btn btn-outline-secondary slot-btn ${daySlot.includes(day) ? 'active' : ''}`}
                          onClick={() => handleDaysButtonClick(day)}
                        >
                          {day}
                        </button>
                      ))}
                    </div>
                    {errors.daySlot && <small className="text-danger">{errors.daySlot}</small>}
                  </div>
                  <div className="col-md-4">
                    <label>Your Profile Picture <span style={{ color: 'red' }}>*</span></label>
                    <label className="vendor-upload-label" htmlFor="profile-picture-upload-button">
                      <Input
                        accept="image/*"
                        id="profile-picture-upload-button"
                        type="file"
                        name="profilePictureFile"
                        onChange={handleFileChangeProfile}
                      />
                      <Button
                        variant="contained"
                        component="span"
                        endIcon={
                          files.profilePictureFile ? (
                            <>
                              <span style={{ fontSize: '15px', marginRight: '8px' }}>{files.profilePictureFile.name}</span>
                              <img
                                src={removeIcon}
                                alt="Remove File Icon"
                                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                onClick={handleFileRemove}
                              />
                            </>
                          ) : (
                            <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
                          )
                        }
                        className="vendor-field-action"
                      >
                        {files.profilePictureFile ? 'Change' : 'Upload'}
                      </Button>
                    </label>
                    {errors.profilePictureFile && <small className="text-danger">{errors.profilePictureFile}</small>}
                    {files.profilePictureFile && (
                      <div style={{ marginTop: '10px' }}>
                        <img
                          src={URL.createObjectURL(files.profilePictureFile)}
                          alt="Profile Preview"
                          style={{ width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover' }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="vendor-form-card">
              <div className="vendor-form-card-head">
                <div>
                  <h2>Emergency Details</h2>
                  <p>Who to contact if this delivery person cannot be reached.</p>
                </div>
              </div>
              <div className="vendor-form-card-body">
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label htmlFor="nameOfEmergency">Name of Emergency <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.nameOfEmergency ? 'is-invalid' : validFields.nameOfEmergency ? 'is-valid' : ''}`}
                      id="nameOfEmergency"
                      name="nameOfEmergency"
                      value={independentDelivery.nameOfEmergency}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('nameOfEmergency', e.target.value)}
                    />
                    {errors.nameOfEmergency && <small className="text-danger">{errors.nameOfEmergency}</small>}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label htmlFor="relationshipToAccountHolder">Relationship to Account Holder <span style={{ color: 'red' }}>*</span></label>
                    <Select
                      options={relationshipOptions}
                      className={`basic-single ${errors.relationshipToAccountHolder ? 'is-invalid' : validFields.relationshipToAccountHolder ? 'is-valid' : ''}`}
                      id="relationshipToAccountHolder"
                      placeholder="Select Relationship"
                      onChange={handleRelationshipChange}
                      value={relationshipOptions.find((option) => option.value === independentDelivery.relationshipToAccountHolder)}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: '#fff',
                          borderColor: errors.relationshipToAccountHolder ? '#dc3545' : validFields.relationshipToAccountHolder ? '#28a745' : '#ced4da',
                          boxShadow: 'none',
                          '&:hover': { borderColor: errors.relationshipToAccountHolder ? '#dc3545' : validFields.relationshipToAccountHolder ? '#28a745' : '#ced4da' },
                        }),
                      }}
                    />
                    {independentDelivery.relationshipToAccountHolder === 'Other' && (
                      <input
                        type="text"
                        className={`form-control bg-light mt-2 ${errors.customRelationship ? 'is-invalid' : validFields.customRelationship ? 'is-valid' : ''}`}
                        placeholder="Enter Custom Relationship"
                        name="customRelationship"
                        value={independentDelivery.customRelationship}
                        onChange={handleCustomRelationshipChange}
                        onBlur={(e) => validateField('customRelationship', e.target.value)}
                      />
                    )}
                    {errors.relationshipToAccountHolder && <small className="text-danger">{errors.relationshipToAccountHolder}</small>}
                    {errors.customRelationship && <small className="text-danger">{errors.customRelationship}</small>}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label htmlFor="emergencyPhoneNumber">Phone Number <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.emergencyPhoneNumber ? 'is-invalid' : validFields.emergencyPhoneNumber ? 'is-valid' : ''}`}
                      id="emergencyPhoneNumber"
                      name="emergencyPhoneNumber"
                      value={independentDelivery.emergencyPhoneNumber}
                      onChange={handleInputChangeIndependent}
                      maxLength="10"
                      pattern="\d*"
                      inputMode="numeric"
                      onBlur={(e) => validateField('emergencyPhoneNumber', e.target.value)}
                    />
                    {errors.emergencyPhoneNumber && <small className="text-danger">{errors.emergencyPhoneNumber}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="emergencyEmailAddress">Email Address <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="email"
                      className={`form-control bg-light ${errors.emergencyEmailAddress ? 'is-invalid' : validFields.emergencyEmailAddress ? 'is-valid' : ''}`}
                      id="emergencyEmailAddress"
                      name="emergencyEmailAddress"
                      value={independentDelivery.emergencyEmailAddress}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('emergencyEmailAddress', e.target.value)}
                    />
                    {errors.emergencyEmailAddress && <small className="text-danger">{errors.emergencyEmailAddress}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="alternateContactPersonName">Alternate Contact Person Name</label>
                    <input
                      type="text"
                      className="form-control bg-light"
                      id="alternateContactPersonName"
                      name="alternateContactPersonName"
                      value={independentDelivery.alternateContactPersonName}
                      onChange={handleInputChangeIndependent}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="relationshipToAlternateContactPerson">Relationship to Alternate Contact Person</label>
                    <input
                      type="text"
                      className="form-control bg-light"
                      id="relationshipToAlternateContactPerson"
                      name="relationshipToAlternateContactPerson"
                      value={independentDelivery.relationshipToAlternateContactPerson}
                      onChange={handleInputChangeIndependent}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="alternateContactPersonNumber">Alternate Contact Person Number</label>
                    <input
                      type="text"
                      className="form-control bg-light"
                      name="alternateContactPersonNumber"
                      value={independentDelivery.alternateContactPersonNumber}
                      onChange={handleInputChangeIndependent}
                      maxLength="10"
                      pattern="\d*"
                      inputMode="numeric"
                      onBlur={(e) => validateField('alternateContactPersonNumber', e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="emergencyAddress">Address <span style={{ color: 'red' }}>*</span></label>
                    <textarea
                      className={`form-control bg-light ${errors.emergencyAddress ? 'is-invalid' : validFields.emergencyAddress ? 'is-valid' : ''}`}
                      id="emergencyAddress"
                      rows="2"
                      name="emergencyAddress"
                      value={independentDelivery.emergencyAddress}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('emergencyAddress', e.target.value)}
                    />
                    {errors.emergencyAddress && <small className="text-danger">{errors.emergencyAddress}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="alternateContactPersonAddress">Alternate Contact Person Address</label>
                    <textarea
                      className="form-control bg-light"
                      id="alternateContactPersonAddress"
                      rows="2"
                      name="alternateContactPersonAddress"
                      value={independentDelivery.alternateContactPersonAddress}
                      onChange={handleInputChangeIndependent}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="vendor-form-card">
              <div className="vendor-form-card-head">
                <div>
                  <h2>TAT Schedule</h2>
                  <p>Pickup time, delivery time, and maximum capacity.</p>
                </div>
              </div>
              <div className="vendor-form-card-body">
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="toPickupLocationTime">To Pickup Location Time <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="number"
                      className={`form-control bg-light ${errors.toPickupLocationTime ? 'is-invalid' : validFields.toPickupLocationTime ? 'is-valid' : ''}`}
                      id="toPickupLocationTime"
                      name="toPickupLocationTime"
                      value={independentDelivery.toPickupLocationTime}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('toPickupLocationTime', e.target.value)}
                    />
                    {errors.toPickupLocationTime && <small className="text-danger">{errors.toPickupLocationTime}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="toDeliveryLocationTime">To Delivery Location Time <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="number"
                      className={`form-control bg-light ${errors.toDeliveryLocationTime ? 'is-invalid' : validFields.toDeliveryLocationTime ? 'is-valid' : ''}`}
                      id="toDeliveryLocationTime"
                      name="toDeliveryLocationTime"
                      value={independentDelivery.toDeliveryLocationTime}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('toDeliveryLocationTime', e.target.value)}
                    />
                    {errors.toDeliveryLocationTime && <small className="text-danger">{errors.toDeliveryLocationTime}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="maximumDeliveryCapacity">Maximum Delivery Capacity <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="number"
                      className={`form-control bg-light ${errors.maximumDeliveryCapacity ? 'is-invalid' : validFields.maximumDeliveryCapacity ? 'is-valid' : ''}`}
                      id="maximumDeliveryCapacity"
                      name="maximumDeliveryCapacity"
                      value={independentDelivery.maximumDeliveryCapacity}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('maximumDeliveryCapacity', e.target.value)}
                    />
                    {errors.maximumDeliveryCapacity && <small className="text-danger">{errors.maximumDeliveryCapacity}</small>}
                  </div>
                </div>
              </div>
            </div>

            <div className="vendor-form-card">
              <div className="vendor-form-card-head">
                <div>
                  <h2>Bank Account Details</h2>
                  <p>Payout account, IFSC, branch, and GPay number.</p>
                </div>
              </div>
              <div className="vendor-form-card-body">
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label htmlFor="accountHoldersName">Account Holder's Name <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.accountHoldersName ? 'is-invalid' : validFields.accountHoldersName ? 'is-valid' : ''}`}
                      id="accountHoldersName"
                      name="accountHoldersName"
                      value={independentDelivery.accountHoldersName}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('accountHoldersName', e.target.value)}
                    />
                    {errors.accountHoldersName && <small className="text-danger">{errors.accountHoldersName}</small>}
                  </div>
                  <div className="col-md-4 mb-3" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label>Type Of Account <span style={{ color: 'red' }}>*</span></label>
                    <div className={`btn-group bg-light ${errors.typeOfAccount ? 'is-invalid' : validFields.typeOfAccount ? 'is-valid' : ''}`} role="group" aria-label="Type of Account">
                      <button
                        type="button"
                        className={`btn btn-outline-secondary ${independentDelivery.typeOfAccount === 'Current' ? 'active' : ''}`}
                        onClick={() => handleAccountTypeChange('Current')}
                      >
                        Current
                      </button>
                      <button
                        type="button"
                        className={`btn btn-outline-secondary ${independentDelivery.typeOfAccount === 'Savings' ? 'active' : ''}`}
                        onClick={() => handleAccountTypeChange('Savings')}
                      >
                        Saving
                      </button>
                    </div>
                    {errors.typeOfAccount && <small className="text-danger">{errors.typeOfAccount}</small>}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label htmlFor="accountNumber">Account Number <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.accountNumber ? 'is-invalid' : validFields.accountNumber ? 'is-valid' : ''}`}
                      id="accountNumber"
                      name="accountNumber"
                      value={independentDelivery.accountNumber}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('accountNumber', e.target.value)}
                    />
                    {errors.accountNumber && <small className="text-danger">{errors.accountNumber}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="ifscCode">IFSC Code <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.ifscCode ? 'is-invalid' : validFields.ifscCode ? 'is-valid' : ''}`}
                      id="ifscCode"
                      name="ifscCode"
                      value={independentDelivery.ifscCode}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('ifscCode', e.target.value)}
                    />
                    {errors.ifscCode && <small className="text-danger">{errors.ifscCode}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="branchName">Branch Name <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.branchName ? 'is-invalid' : validFields.branchName ? 'is-valid' : ''}`}
                      id="branchName"
                      name="branchName"
                      value={independentDelivery.branchName}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('branchName', e.target.value)}
                    />
                    {errors.branchName && <small className="text-danger">{errors.branchName}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="gpayNumber">Gpay Number <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.gpayNumber ? 'is-invalid' : validFields.gpayNumber ? 'is-valid' : ''}`}
                      id="gpayNumber"
                      name="gpayNumber"
                      value={independentDelivery.gpayNumber}
                      onChange={handleInputChangeIndependent}
                      maxLength="10"
                      pattern="\d*"
                      inputMode="numeric"
                      onBlur={(e) => validateField('gpayNumber', e.target.value)}
                    />
                    {errors.gpayNumber && <small className="text-danger">{errors.gpayNumber}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="bankAddress">Bank Address <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control bg-light ${errors.bankAddress ? 'is-invalid' : validFields.bankAddress ? 'is-valid' : ''}`}
                      id="bankAddress"
                      placeholder="Enter Bank Address"
                      name="bankAddress"
                      value={independentDelivery.bankAddress}
                      onChange={handleInputChangeIndependent}
                      onBlur={(e) => validateField('bankAddress', e.target.value)}
                    />
                    {errors.bankAddress && <small className="text-danger">{errors.bankAddress}</small>}
                  </div>
                </div>
              </div>
            </div>

            <div className="vendor-form-card">
              <div className="vendor-form-card-head">
                <div>
                  <h2>Delivery Partner Documents</h2>
                  <p>Identity and license files for this delivery person.</p>
                </div>
              </div>
              <div className="vendor-form-card-body">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Document Name <span style={{ color: 'red' }}>*</span></th>
                      <th>Document Number <span style={{ color: 'red' }}>*</span></th>
                      <th>Document Type <span style={{ color: 'red' }}>*</span></th>
                      <th>Document Upload <span style={{ color: 'red' }}>*</span></th>
                      <th>Document Expiry Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents.map((doc, index) => (
                      <tr key={index}>
                        <td>
                          <Select
                            options={getAvailableDocumentOptions(index)}
                            className={`basic-single ${errors.documents && !doc.name ? 'is-invalid' : doc.name ? 'is-valid' : ''}`}
                            placeholder="Select Document"
                            onChange={(selectedOption) => handleDocumentChange(index, selectedOption)}
                            value={documentOptions.find((option) => option.value === doc.name)}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                backgroundColor: '#fff',
                                borderColor: errors.documents && !doc.name ? '#dc3545' : doc.name ? '#28a745' : '#ced4da',
                                boxShadow: 'none',
                                '&:hover': { borderColor: errors.documents && !doc.name ? '#dc3545' : doc.name ? '#28a745' : '#ced4da' },
                              }),
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className={`form-control bg-light ${errors[`documentnumber${index}`] || (errors.documents && !doc.number) ? 'is-invalid' : doc.number ? 'is-valid' : ''}`}
                            value={doc.number}
                            placeholder="Enter Document Number"
                            onChange={(e) => handleChange(index, 'number', e.target.value)}
                            onBlur={() => {
                              if (!String(doc.number || '').trim()) {
                                setErrors((prev) => ({ ...prev, [`documentnumber${index}`]: 'Document Number is required' }));
                                setValidFields((prev) => ({ ...prev, [`documentnumber${index}`]: false }));
                              }
                              validateField('documents', documents);
                            }}
                          />
                          {errors[`documentnumber${index}`] && <small className="text-danger">{errors[`documentnumber${index}`]}</small>}
                        </td>
                        <td>
                          <select
                            className={`form-control bg-light ${errors[`documenttype${index}`] || (errors.documents && !doc.type) ? 'is-invalid' : doc.type ? 'is-valid' : ''}`}
                            value={doc.type}
                            onChange={(e) => handleChange(index, 'type', e.target.value)}
                            onBlur={() => {
                              if (!doc.type) {
                                setErrors((prev) => ({ ...prev, [`documenttype${index}`]: 'Document Type is required' }));
                                setValidFields((prev) => ({ ...prev, [`documenttype${index}`]: false }));
                              }
                              validateField('documents', documents);
                            }}
                            style={{
                              backgroundImage: `url(${arrow})`,
                              backgroundPosition: 'right 10px center',
                              backgroundRepeat: 'no-repeat',
                              backgroundSize: '16px 16px',
                              paddingRight: '30px',
                              color: 'gray',
                            }}
                          >
                            <option value="">Select Type</option>
                            <option value="pdf">PDF</option>
                            <option value="doc">DOC</option>
                            <option value="jpg">JPG</option>
                            <option value="jpeg">JPEG</option>
                            <option value="png">PNG</option>
                            {doc.type && !['pdf', 'doc', 'jpg', 'jpeg', 'png'].includes(doc.type) && (
                              <option value={doc.type}>{String(doc.type).toUpperCase()}</option>
                            )}
                          </select>
                          {errors[`documenttype${index}`] && <small className="text-danger">{errors[`documenttype${index}`]}</small>}
                        </td>
                        <td>
                          <label
                            className="vendor-upload-label"
                            htmlFor={doc.type ? `file-upload-${index}` : undefined}
                            onClick={(event) => {
                              if (!doc.type) event.preventDefault();
                            }}
                          >
                            <input
                              type="file"
                              id={`file-upload-${index}`}
                              style={{ display: 'none' }}
                              accept={documentTypeAccept[doc.type] || ''}
                              onChange={(e) => handleFileChange(index, e)}
                            />
                            {doc.upload ? (
                              <button
                                type="button"
                                className={`vendor-field-action ${errors[`documentupload${index}`] ? 'border-danger' : 'border-success'}`}
                                onClick={() => removeFile(index)}
                              >
                                <span style={{ flex: 1, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                  {doc.fileName || doc.upload.name}
                                </span>
                                <img src={deleteicon} alt="Remove" style={{ width: '20px', height: '20px', marginLeft: '10px' }} />
                              </button>
                            ) : (
                              <button
                                type="button"
                                className={`vendor-field-action ${errors[`documentupload${index}`] ? 'border-danger' : ''}`}
                                disabled={!doc.type}
                                onClick={() => {
                                  if (!doc.type) {
                                    setErrors((prev) => ({ ...prev, [`documenttype${index}`]: 'Select a document type before uploading' }));
                                    return;
                                  }
                                  document.getElementById(`file-upload-${index}`).click();
                                }}
                              >
                                <span>Upload</span>
                                <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px' }} />
                              </button>
                            )}
                          </label>
                          {errors[`documentupload${index}`] && <small className="text-danger">{errors[`documentupload${index}`]}</small>}
                        </td>
                        <td>
                          <input
                            type="date"
                            className="form-control bg-light"
                            value={doc.expiryDate}
                            onChange={(e) => handleChange(index, 'expiryDate', e.target.value)}
                          />
                        </td>
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <p onClick={addRow} style={{ margin: 0, cursor: 'pointer' }}>
                              <img src={add} alt="Add" style={{ width: '34px', height: '34px' }} />
                            </p>
                            <button
                              className="btn btn-danger btn-sm rounded-circle"
                              onClick={() => deleteRow(index)}
                              style={{ width: '30px', height: '30px' }}
                            >
                              <img src={deleteicon} alt="Delete" style={{ width: '16px', height: '16px', marginTop: '-5px', marginLeft: '-2px' }} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {errors.documents && <small className="text-danger">{errors.documents}</small>}
              </div>
            </div>
          </div>
          <div className="vendor-form-actions">
            <button type="button" className="vendor-form-cancel" onClick={() => window.history.back()}>Cancel</button>
            <button
              type="button"
              className="vendor-form-submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              Save and Submit
            </button>
          </div>
        </div>
              {/* Location Picker Modal */}
      <div className={`modal fade vendor-map-modal ${isMapOpen ? 'show d-block' : ''}`} tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered vendor-map-dialog">
          <div className="modal-content vendor-map-content">
            <div className="modal-header vendor-map-header">
              <div>
                <p>Location</p>
                <h5 className="modal-title">Select Delivery Person Location</h5>
              </div>
              <button type="button" className="btn-close" onClick={() => setIsMapOpen(false)}></button>
            </div>
            <div className="modal-body vendor-map-body">
              <p className="vendor-map-hint">Search an address, enter coordinates, or click the map to drop a pin.</p>
              <div className="vendor-map-search">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search place (e.g., Rajapalayam Bus Stand)"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleGeocode()}
                />
                <button type="button" className="vendor-map-search-btn" onClick={handleGeocode}>Search</button>
              </div>

              {/* Manual Lat/Lng */}
              <div className="vendor-map-coords">
                <div>
                  <label>Latitude</label>
                  <input
                    type="number"
                    className="form-control"
                    step="any"
                    value={manualLat}
                    onChange={(e) => {
                      const v = e.target.value;
                      setManualLat(v);
                      if (v && manualLng) {
                        updateLocation({ lat: parseFloat(v), lng: parseFloat(manualLng) });
                      }
                    }}
                  />
                </div>
                <div>
                  <label>Longitude</label>
                  <input
                    type="number"
                    className="form-control"
                    step="any"
                    value={manualLng}
                    onChange={(e) => {
                      const v = e.target.value;
                      setManualLng(v);
                      if (v && manualLat) {
                        updateLocation({ lat: parseFloat(manualLat), lng: parseFloat(v) });
                      }
                    }}
                  />
                </div>
              </div>

              {/* Map */}
              <div className="vendor-map-frame">
                <MapContainer
                  center={mapCenter}
                  zoom={mapZoom}
                  style={{ height: "100%", width: "100%" }}
                  ref={mapRef}
                >
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <MapClickHandler onSelect={updateLocation} />
                  {mapMarker && <Marker position={[mapMarker.lat, mapMarker.lng]} />}
                </MapContainer>
              </div>
            </div>
            <div className="modal-footer vendor-map-footer">
              <button type="button" className="vendor-map-cancel" onClick={() => setIsMapOpen(false)}>
                Cancel
              </button>
              <button
                type="button"
                className="vendor-map-confirm"
                disabled={!mapMarker}
                onClick={() => {
                  toast.success(`Location confirmed: ${mapMarker.lat.toFixed(6)}, ${mapMarker.lng.toFixed(6)}`);
                  setIsMapOpen(false);
                }}
              >
                Confirm Location
              </button>
            </div>
          </div>
        </div>
      </div>
        <div className="vendor-form-footer">
          <Footer />
        </div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ zIndex: 9999 }}
        />
      </div>
    </>
  );
};

export default AddIndependentDelivery;